import { useMemo } from 'react';
import { useRouter } from 'next/router';
import mapValues from 'lodash/mapValues';
import map from 'lodash/map';

import { CompactPeopleSecondaryMenuLinksConfig } from './useCompactPeopleSecondaryMenu.types';
import { IconsEnum } from '../../../../../../../assets/icons/types';

import { TeamPath } from '../../../../../../teams/TeamPath';

import { getPeopleActiveMenu } from '../../utils/getPeopleActiveMenu';

import { TeamsPermissions } from '../../../../../../teams/teamsConstants';

import { teamsKeys, menuKeys } from '../../../../../../../locales/keys';

function useCompactPeopleSecondaryMenu() {
  const { pathname } = useRouter();

  const config = useMemo<CompactPeopleSecondaryMenuLinksConfig>(
    () => ({
      companies: [
        {
          action: TeamsPermissions.READ_COMPANIES_COMPACT_MENU_INDEX_LINK,
          active: pathname === TeamPath.companiesCompact(),
          href: TeamPath.companiesCompact(),
          i18nText: teamsKeys.allCompanies,
          icon: IconsEnum.VIEW_LIST
        },
        {
          action:
            TeamsPermissions.READ_COMPANIES_COMPACT_MENU_MY_COMPANIES_LINK,
          active: pathname === TeamPath.companiesCompactMyCompanies(),
          href: TeamPath.companiesCompactMyCompanies(),
          i18nText: teamsKeys.myCompanies,
          icon: IconsEnum.VIEW_LIST_USER_SOLID
        },
        {
          action: TeamsPermissions.READ_COMPANIES_COMPACT_MENU_BLOCKED_LINK,
          active: pathname === TeamPath.companiesCompactBlocked(),
          href: TeamPath.companiesCompactBlocked(),
          i18nText: teamsKeys.blockedCompanies,
          icon: IconsEnum.VIEW_LIST_NO_SYMBOL_SOLID
        },
        {
          action: TeamsPermissions.READ_COMPANIES_COMPACT_MENU_UNASSIGNED_LINK,
          active: pathname === TeamPath.companiesCompactUnassigned(),
          href: TeamPath.companiesCompactUnassigned(),
          i18nText: menuKeys.links.unassigned,
          icon: IconsEnum.FIRE_SOLID
        }
      ],
      performers: [
        {
          action: TeamsPermissions.READ_PERFORMERS_COMPACT_MENU_INDEX_LINK,
          active: pathname === TeamPath.performersCompact(),
          href: TeamPath.performersCompact(),
          i18nText: menuKeys.links.all,
          icon: IconsEnum.VIEW_LIST_SOLID
        },
        {
          action:
            TeamsPermissions.READ_PERFORMERS_COMPACT_MENU_MY_PERFORMERS_LINK,
          active: pathname === TeamPath.performersCompactMyPerformers(),
          href: TeamPath.performersCompactMyPerformers(),
          i18nText: menuKeys.links.my,
          icon: IconsEnum.VIEW_LIST_USER_SOLID
        },
        {
          action: TeamsPermissions.READ_PERFORMERS_COMPACT_MENU_FAVORITE_LINK,
          active: pathname === TeamPath.performersCompactFavorite(),
          href: TeamPath.performersFavorite(),
          i18nText: menuKeys.links.favorite,
          icon: IconsEnum.FILLED_STAR
        },
        {
          action: TeamsPermissions.READ_PERFORMERS_COMPACT_MENU_UNASSIGNED_LINK,
          active: pathname === TeamPath.performersCompactUnassigned(),
          href: TeamPath.performersUnassigned(),
          i18nText: menuKeys.links.unassigned,
          icon: IconsEnum.BURNING
        },
        {
          action: TeamsPermissions.READ_PERFORMERS_COMPACT_MENU_TAT_LINK,
          active: pathname === TeamPath.performersCompactTat(),
          href: TeamPath.performersTat(),
          i18nText: teamsKeys.tat,
          icon: IconsEnum.COLLECTION_SOLID
        },
        {
          action: TeamsPermissions.READ_PERFORMERS_COMPACT_MENU_BLOCKED_LINK,
          active: pathname === TeamPath.performersCompactBlocked(),
          href: TeamPath.performersBlocked(),
          i18nText: menuKeys.links.blocked,
          icon: IconsEnum.RECEIPT_REFUND
        }
      ]
    }),
    [pathname]
  );

  const activeMenu = getPeopleActiveMenu(pathname);

  return {
    activeMenu,
    config,
    permissions: mapValues(config, (item) => map(item, 'action'))
  };
}

export default useCompactPeopleSecondaryMenu;
